import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Group, KeypadOption, NoInfo, UserList } from '../styles/dialpadstyle';
import { RecentList } from './dialpad'
import { connect } from 'react-redux';
import SpinnerIcon from '../../../../common/components/SpinnerIcon'
import { globalStateSelector } from '../../../../../store/selector';
import {
  globalAction,
} from '../../../../../store/action';
import CommonManager from '../../../../../helpers/common';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  Spinner,
  FormControl,
  Button
} from 'modules/theme';
import styled from 'styled-components';
const commonManager = new CommonManager();
global.__callBtn = "";


const CustomKeypadOption = styled.div`

	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px;

	input {
		height: 38px;
		border-radius: 19px;
	}
`
const OnlineScreenThemeResponsive = styled.div`
  display: flex;
  flex-direction: column;
  height: 360px;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`
export class OnlineScreenTheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading : false,
      phoneNumber: ""
    }
    this.startTimer = this.startTimer.bind(this);

  }
  renderFormGroup(label, props) {
    return (
      <FormGroup className="mb-0">
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  startTimer() {
    const { dynamicUpdate } = this.props
    clearTimeout(global.__callBtn);
    if( this.state.phoneNumber && this.state.phoneNumber.length > 3 ) {
      this.setState({"loading":true})
      dynamicUpdate({ key: 'callHandlingLoader', value: true });
      global.__callBtn  = setTimeout(()=>{
        dynamicUpdate({ key: 'callHandlingLoader', value: false });
      },10000)
    }
  }
  getTypeUrl(type) {
    // if (type == 'Inbound' || type == 'incomming' ) {
    //   return '/images/icons/incoming.png';
    // } else if( type == 'Missed' ){
    //   return '/images/icons/missed.png';
    // }
    return type;
    // return (
    //   <div class="call-icon">
    //     <span class="bg-yellow material-symbols-rounded">
    //       call
    //     </span>
    //   </div>
    // );
  }
  componentDidMount(){
    let list=[]
    // this.props.teamList.map(e=>{
    //   if(e.numberMasking===true){
    //     list.push(e._id)
    //     // map1.set(`${e._id}`,e._id)
    //   }
    //   // list.push({numberMasking:e.numberMasking,name:e.name,_id:e._id})
    // })
    // this.setState({map1:list},()=>{
    // })
  }
  render() {

  }
  render() {

    const {
      btnCall,
      btnKeypad,
      onNumberKeyPress,
      onNumberChange,
      onCall,
      callList,
      callProcess,
      teamList,
      callLoader,
      dynamicUpdate,
      teamName,
      team,
      onKeypadChange
    } = this.props;

    let numberMask = {}; 
    try {
      teamList.map(e=>{
        numberMask[e._id] = e.numberMasking || false;
      });
    } catch (error) {
    }
    return (
      <OnlineScreenThemeResponsive>
        <div>
          <CustomKeypadOption>
            <div className="flex-grow-1">
              <div className="mb-0">
                {this.renderFormGroup('', {
                  type: 'tel',
                  defaultValue: '',
                  //placeholder: teamName ? `Dial number using ${teamName}` : "",
                  placeholder: `Input number to call (${teamName})`,
                  autoFocus: false,
                  required: true,
                  disabled: teamName ? false : true,
                  id: 'number',
                  value: this.props.number,
                  onKeyPress: onNumberKeyPress,
                  // onKeyPress:teamName ? (event)=>{
                  //   onNumberKeyPress(event);
                  //   if (event.key === 'Enter') {
                  //     this.startTimer();
                  //   }
                  // }:()=>{ // restricted data
                  // },
                  // onChange: onNumberChanges,
                  onChange: (event)=>{
                    // if ( event.target.value ) {
                    //   this.setState({phoneNumber : event.target.value})
                    // } else {
                    //   this.setState({phoneNumber : ""})
                    // }
                    onNumberChange(event)
                  }
                })}
              </div>
            </div>
            <Button
				btnStyle="link"
				type="simple"
				disabled = {teamName ? false : true}
				style={{padding:0,borderRadius: '50%', margin: 5}}
				onClick={
					teamName ?
					()=>{
						this.startTimer();
						onCall();
					} : 
					()=>{}
				}
            >

              { !callLoader && <img src={btnCall} style={{ width: '38px' }}  /> }
              { callLoader && <SpinnerIcon style={{
                  width: "38px",
                  marginTop: "0px",
                  paddingTop: "6px",
                  justifyContent: "center",
                  height: "38px",
                  background: "#eee7f9",
                  borderRadius: "20px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}/>
              }
            </Button>
			<Button
				btnStyle="link"
				type="simple"
				style={{ borderRadius: '50%', padding: 0, margin: 5 }}
				onClick={e => onKeypadChange(e)}
			>
				<img src={btnKeypad} style={{ width: '38px' }} />
			</Button>
          </CustomKeypadOption>
        </div>
        <UserList style={{height: "auto"}}>
          {
            callList && callList.length ?
              (
                <React.Fragment>
                  {callList.map(data => {
                    let agentNumber = data.name;
                    if(numberMask[data.teamId] ){
                      agentNumber = commonManager.maskText(data.name);
                    }
                    return (
                      <RecentList
                        image={this.getTypeUrl(data.type)}
                        iconWidth={"20px"}
                        name={agentNumber}
                        message={data.message}
                        time={data.time}
                        dialNumber={callProcess}
                        callInfo={data}
                      />
                    );
                  })}
                </React.Fragment>
              ) :
              <NoInfo>
                <img src="images/clock_history.png" />
                <span>Your call history in empty</span>
                <h4>No Call History</h4>
              </NoInfo>
          }
        </UserList>
      </OnlineScreenThemeResponsive>
    )
  }
}

OnlineScreenTheme.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  teamName: globalStateSelector.getDynamic(state, { key: 'dialPadTeamName' }),
  callLoader: globalStateSelector.getDynamic(state, { key: 'callHandlingLoader' }),
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
});
export default connect(stateToProps, dispatchToProps)(OnlineScreenTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/OnlineScreenTheme.js